const state = {
  selected: {},
  userName: '',
  plans: [],
  esquecisenha: false,
  imagensSrc:{ 
    'AMEPLAN': "http://www.corporeadministradora.com.br/wp-content/uploads/2019/03/Ameplan-150x150.jpg",
    'BIOVIDA': "http://www.corporeadministradora.com.br/wp-content/uploads/2019/03/biovida-1-150x150.jpg",
    'DENTALPAR': "http://www.corporeadministradora.com.br/wp-content/uploads/2019/03/Dentalpar-1-150x150.jpg",
    'GREEN LINE': 'http://www.corporeadministradora.com.br/wp-content/uploads/2019/05/greenline-1-150x150.jpg',
    'NOTREDAME': 'http://www.corporeadministradora.com.br/wp-content/uploads/2019/03/Notre-Dame-150x150.jpg',
    'PLAMESC': 'http://www.corporeadministradora.com.br/wp-content/uploads/2019/05/logo-plamesc-150x150.png',
    'PLENA': 'http://www.corporeadministradora.com.br/wp-content/uploads/2019/03/Plena-1.jpg',
    'SANTÁMALIA': 'http://www.corporeadministradora.com.br/wp-content/uploads/2019/03/Notre-Dame-150x150.jpg',
    'SAO CRISTOVAO': 'http://www.corporeadministradora.com.br/wp-content/uploads/2019/03/SC-150x150.jpg',
    'UNIHOSP ': 'http://www.corporeadministradora.com.br/wp-content/uploads/2019/03/Unihosp-150x150.jpg',
    'UNIMED VR | UNIDADE VOLTA REDONDA': 'http://www.corporeadministradora.com.br/wp-content/uploads/2019/03/Unimed-VR-150x150.jpg',
    'VITALLIS': 'http://www.corporeadministradora.com.br/wp-content/uploads/2019/03/Vitallis-150x150.jpg',
  }
}
const mutations = {
  getAllBeneficiaries: async ( { }, plans) => {
    return plans.reduce((listBeneficiaries, p) => listBeneficiaries.concat(p.beneficiarios), [])
       .reduce((newList, e) => (newList.findIndex(item => item.cpf == e.cpf) == -1)? newList.concat(e) : newList, [])
   },
  savePlans: (state, plans) => {
    if(plans && plans.length){
      state.plans = plans
      state.userName = plans.reduce((acum, plan) => acum.concat(plan.beneficiarios), [])
                        .find(person => person.cpf == localStorage.corporeUserId)
                        .nome.split(' ')[0]
    }
  },
  esquecisenha: (state, bool) => {
    state.esquecisenha = bool
  }
}

export default {
  namespaced: true,
  root: true,
  state,
  mutations
}